import { gql } from "@apollo/client";

export default gql`
  mutation saveAssessmentNominees(
    $complianceProgramId: Int!
    $assessmentTemplateId: Int!
    $responderIds: [Int]!
    $targetId: Int!
  ) {
    setAssessmentNominations(
      complianceProgramId: $complianceProgramId
      assessmentTemplateId: $assessmentTemplateId
      responderIds: $responderIds
      targetId: $targetId
    ) {
      complianceProgram {
        id
        nominationsForUser(userId: $targetId) {
          edges {
            node {
              id
              responder {
                id
                name
                avatar
              }
              responderId
              responderName
              responderDeactivated
            }
          }
        }
      }
      assessmentOpenForNomination {
        id
        nominationsCount
      }
    }
  }
`;
